import { render, staticRenderFns } from "./abstract.vue?vue&type=template&id=1455e8be&scoped=true"
import script from "./abstract.vue?vue&type=script&lang=js"
export * from "./abstract.vue?vue&type=script&lang=js"
import style0 from "./abstract.vue?vue&type=style&index=0&id=1455e8be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455e8be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1455e8be')) {
      api.createRecord('1455e8be', component.options)
    } else {
      api.reload('1455e8be', component.options)
    }
    module.hot.accept("./abstract.vue?vue&type=template&id=1455e8be&scoped=true", function () {
      api.rerender('1455e8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/components/process_approve/abstract.vue"
export default component.exports